import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";
import getAppsQuery from "./queries/getApps";
import getSettingsQuery from "./queries/getSettings";
import getApprovalRequestsQuery from "./queries/getApprovalRequests";
import setSettingsMutation from "./mutations/setSettings";


const getApps = (orgId, propertyId) => {
    let variables = { orgId, propertyId };
    return fetchQuery(environment, getAppsQuery, variables)
        .then(res => {
            return res;
        })
        .catch(err => {
            return { errors: [{ message: err.toString() }] };
        });
};

const getSettings = (orgId, propertyId) => {
    const variables = { orgId, propertyId };
    return fetchQuery(environment, getSettingsQuery, variables);
}

const getApprovalRequests = (orgId, type, propertyId) => {
    const variables = {
        orgId, type, propertyId
    };
    return fetchQuery(environment, getApprovalRequestsQuery, variables);
}



export {
    getApps,
    getSettings,
    setSettingsMutation,
    getApprovalRequests,

};
